import { useDispatch, useSelector } from "react-redux";
import { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { get, size } from "lodash";
import { URL, apiURL } from "../../../utils/constant";
import { getApiData } from "../../selector/auth.selector";
import {
  getSelectedDate,
  getSelectedVisit,
} from "../../selector/visits.selector";
import { toast } from "react-toastify";
import joi from "joi";
import {
  getBSSubmitFlag,
  getListFlag,
  getSelectedList,
} from "../../selector/bloodSugarRecord.selector";
import {
  setBSSubmitFlag,
  setBloodSugarFlag,
} from "../../reducer/bloodSugarRecord.reducer";
import { useNavigate } from "react-router-dom";
import UseBloodSugarRecordList from "./UseBloodSugarRecordList";
import { useRef } from "react";
import { useEffect } from "react";
import { English } from "../../../Languages/en";
import { getLanguage } from "../../selector/language.selector";

export default function useBloodSugarRecord() {
  const loginData = useSelector(getApiData);
  const Language = useSelector(getLanguage);
  const selectedVisit = useSelector(getSelectedVisit);
  const selectedDate = useSelector(getSelectedDate);
  const [loading, setLoading] = useState(false);
  const listData = useSelector(getSelectedList);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getListflag = useSelector(getListFlag);
  const getListFlagRef = useRef(getListflag); // Create a ref to store the current value of getListFlag

  // Update the ref's value whenever getListflag changes
  useEffect(() => {
    getListFlagRef.current = getListflag;
  }, [getListflag]);

  const handleSubmitFlagChange = () => {
    dispatch(setBSSubmitFlag((prevFlag) => !prevFlag));
  };

  const selectedListData = {};

  listData?.ItemList?.forEach((item) => {
    selectedListData[item?.ItemId] = item?.ItemValue;
  });
  selectedListData["RowNum"] = listData?.RowNum;
  const submitBSData = useCallback(
    async ({
      date,
      Basal_Insulin,
      Blood_sugar_value,
      Bolus_Insulin,
      Pump_Insulin_Units,
      PageID,
      formattedMealTime,
      timeDropdownValue,
      mealCodeDropdownValue,
      insulinTypeDropdownValue,
      insulinType2DropdownValue,
      pumpInsulinTypeDropdownValue,
    }) => {
      try {
        setLoading(true);

        const objSubmit = {
          date,
          Basal_Insulin,
          Blood_sugar_value,
          Bolus_Insulin,
          Pump_Insulin_Units,
          PageID,
          formattedMealTime,
          timeDropdownValue,
          mealCodeDropdownValue,
          insulinTypeDropdownValue,
          insulinType2DropdownValue,
          pumpInsulinTypeDropdownValue,
        };
        const selectedMealCodeDropdownValue =
          English?.BloodSugarRecords.Meal_Code_Dropdown.find((item) => {
            return item?.id === mealCodeDropdownValue;
          })?.name;

        const selectedTimeDropdownValue =
          English?.BloodSugarRecords.Time_Dropdown.find((item) => {
            return item?.id === timeDropdownValue;
          })?.name;

        const selectedInsulinTypeDropdownValue =
          English?.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
            return item?.id === insulinTypeDropdownValue;
          })?.name;

        const selectedInsulinType2DropdownValue =
          English?.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
            return item?.id === insulinType2DropdownValue;
          })?.name;

        const selectedPumpInsulineTypeDropdownValue =
          English?.BloodSugarRecords.Pump_Insulin_Type_Dropdown.find((item) => {
            return item?.id === pumpInsulinTypeDropdownValue;
          })?.name;

        const { data } = await Api.post({
          url: apiURL.submitData(),
          data: prepareDataForSubmission({
            date,
            Basal_Insulin,
            Blood_sugar_value,
            Bolus_Insulin,
            Pump_Insulin_Units,
            PageID,
            formattedMealTime,
            selectedTimeDropdownValue,
            selectedMealCodeDropdownValue,
            selectedInsulinTypeDropdownValue,
            selectedInsulinType2DropdownValue,
            selectedPumpInsulineTypeDropdownValue,
          }),
        });

        handleResponse(data, PageID, getListFlagRef.current); // Use the ref's value
        setLoading(false);
        dispatch(setBloodSugarFlag(false));
        return true;
      } catch (err) {
        console.log("submit BS ERROR ::  ", err);
        setLoading(false);
        return false;
      }
    }
  );

  const updateBSData = useCallback(
    async ({
      date,
      Basal_Insulin,
      Blood_sugar_value,
      Bolus_Insulin,
      Pump_Insulin_Units,
      PageID,
      formattedMealTime,
      timeDropdownValue,
      mealCodeDropdownValue,
      insulinTypeDropdownValue,
      insulinType2DropdownValue,
      pumpInsulinTypeDropdownValue,
    }) => {
      try {
        setLoading(true);

        const objUpdate = {
          date,
          Basal_Insulin,
          Blood_sugar_value,
          Bolus_Insulin,
          Pump_Insulin_Units,
          PageID,
          formattedMealTime,
          timeDropdownValue,
          mealCodeDropdownValue,
          insulinTypeDropdownValue,
          insulinType2DropdownValue,
          pumpInsulinTypeDropdownValue,
        };

        const selectedMealCodeDropdownValue =
          English?.BloodSugarRecords.Meal_Code_Dropdown.find((item) => {
            return item?.id === mealCodeDropdownValue;
          })?.name;

        const selectedTimeDropdownValue =
          English?.BloodSugarRecords.Time_Dropdown.find((item) => {
            return item?.id === timeDropdownValue;
          })?.name;

        const selectedInsulinTypeDropdownValue =
          English?.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
            return item?.id === insulinTypeDropdownValue;
          })?.name;

        const selectedInsulinType2DropdownValue =
          English?.BloodSugarRecords.Insulin_Type_Dropdown.find((item) => {
            return item?.id === insulinType2DropdownValue;
          })?.name;

        const selectedPumpInsulineTypeDropdownValue =
          English?.BloodSugarRecords.Pump_Insulin_Type_Dropdown.find((item) => {
            return item?.id === pumpInsulinTypeDropdownValue;
          })?.name;

        const { data } = await Api.post({
          url: apiURL.updateFormData(),
          data:
            prepareDataForUpdate &&
            prepareDataForUpdate({
              date,
              Basal_Insulin,
              Blood_sugar_value,
              Bolus_Insulin,
              Pump_Insulin_Units,
              PageID,
              formattedMealTime,
              selectedTimeDropdownValue,
              selectedMealCodeDropdownValue,
              selectedInsulinTypeDropdownValue,
              selectedInsulinType2DropdownValue,
              selectedPumpInsulineTypeDropdownValue,
            }),
        });

        handleResponse(data, PageID, getListFlagRef.current); // Use the ref's value
        setLoading(false);
        dispatch(setBloodSugarFlag(false));
        return true;
      } catch (err) {
        console.log("update BS ERROR ::  ", err);
        setLoading(false);
        return false;
      }
    }
  );

  const prepareDataForSubmission = ({
    // date,
    Basal_Insulin,
    Blood_sugar_value,
    Bolus_Insulin,
    Pump_Insulin_Units,
    PageID,
    formattedMealTime,
    selectedTimeDropdownValue,
    selectedMealCodeDropdownValue,
    selectedInsulinTypeDropdownValue,
    selectedInsulinType2DropdownValue,
    selectedPumpInsulineTypeDropdownValue,
  }) => {
    const formattedDate = String(selectedDate);
    const subjectId = get(loginData, "SubjectId", "");
    const siteId = get(loginData, "SiteId", "");
    const trialId = get(loginData, "TrialId", "");
    const visitNo = String(get(selectedVisit, "VisitNo", ""));
    const visitId = get(selectedVisit, "VisitId", "");
    const visitCode = String(get(selectedVisit, "VisitCode", ""));
    const InvUserId = parseInt(get(loginData, "InvUserId", ""));

    const params = {
      PageId: PageID,
      SiteId: siteId,
      SubjectId: subjectId,
      TrialId: trialId,
      UserID: InvUserId,
      VisitCode: visitCode,
      VisitId: visitId,
      VisitNo: visitNo,
    };

    return {
      AdditionalBOData: {
        ItemList: [
          { ItemId: "BS_SUGAR", ItemValue: Blood_sugar_value, RowNum: 0 },
          { ItemId: "BS_UNITS", ItemValue: Pump_Insulin_Units, RowNum: 0 },
          {
            ItemId: "BS_PTYPE",
            ItemValue: selectedPumpInsulineTypeDropdownValue,
            RowNum: 0,
          },
          { ItemId: "SUBDAY", ItemValue: "1", RowNum: 0 },
          { ItemId: "BS_DATE", ItemValue: formattedDate, RowNum: 0 },
          {
            ItemId: "BS_TIME",
            ItemValue: selectedTimeDropdownValue,
            RowNum: 0,
          },
          { ItemId: "BS_BINSULIN", ItemValue: Basal_Insulin, RowNum: 0 },
          { ItemId: "BS_INSULIN", ItemValue: Bolus_Insulin, RowNum: 0 },
          {
            ItemId: "MEAL",
            ItemValue: selectedMealCodeDropdownValue,
            RowNum: 0,
          },
          {
            ItemId: "BS_INTYPE",
            ItemValue: selectedInsulinTypeDropdownValue,
            RowNum: 0,
          },
          {
            ItemId: "BS_ITYPE",
            ItemValue: selectedInsulinType2DropdownValue,
            RowNum: 0,
          },
          { ItemId: "BS_MTIME", ItemValue: formattedMealTime, RowNum: 0 },
        ],
        PageId: PageID,
        SiteId: siteId,
        SubjectId: subjectId,
        TrialId: trialId,
        UserID: InvUserId,
        VisitCode: visitCode,
        VisitId: visitId,
        VisitNo: visitNo,
      },
    };
  };

  const prepareDataForUpdate = ({
    // date,
    Basal_Insulin,
    Blood_sugar_value,
    Bolus_Insulin,
    Pump_Insulin_Units,
    PageID,
    formattedMealTime,
    selectedTimeDropdownValue,
    selectedMealCodeDropdownValue,
    selectedInsulinTypeDropdownValue,
    selectedInsulinType2DropdownValue,
    selectedPumpInsulineTypeDropdownValue,
  }) => {
    const formattedDate = String(selectedDate);
    const subjectId = get(loginData, "SubjectId", "");
    const siteId = get(loginData, "SiteId", "");
    const trialId = get(loginData, "TrialId", "");
    const visitNo = String(get(selectedVisit, "VisitNo", ""));
    const visitId = get(selectedVisit, "VisitId", "");
    const visitCode = String(get(selectedVisit, "VisitCode", ""));
    const InvUserId = parseInt(get(loginData, "InvUserId", ""));

    const updatedData = {
      AdditionalBOData: {
        ItemList: [],
        PageId: PageID,
        SiteId: siteId,
        SubjectId: subjectId,
        TrialId: trialId,
        UserID: InvUserId,
        VisitCode: visitCode,
        VisitId: visitId,
        VisitNo: visitNo,
      },
    };

    if (Blood_sugar_value && selectedListData?.BS_SUGAR != Blood_sugar_value) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_SUGAR",
        ItemValue: Blood_sugar_value,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (Basal_Insulin && selectedListData?.BS_BINSULIN != Basal_Insulin) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_BINSULIN",
        ItemValue: Basal_Insulin,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (Bolus_Insulin && selectedListData?.BS_INSULIN != Bolus_Insulin) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_INSULIN",
        ItemValue: Bolus_Insulin,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (
      Pump_Insulin_Units &&
      selectedListData?.BS_UNITS != Pump_Insulin_Units
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_UNITS",
        ItemValue: Pump_Insulin_Units,
        RowNum: selectedListData?.RowNum,
      });
    }
    if (formattedDate && selectedListData?.BS_DATE != formattedDate) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_DATE",
        ItemValue: formattedDate,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (formattedMealTime && selectedListData?.BS_MTIME != formattedMealTime) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_MTIME",
        ItemValue: formattedMealTime,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (
      selectedTimeDropdownValue &&
      selectedListData?.BS_TIME != selectedTimeDropdownValue
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_TIME",
        ItemValue: selectedTimeDropdownValue,
        RowNum: selectedListData?.RowNum,
      });
    }
    if (
      selectedMealCodeDropdownValue &&
      selectedListData?.MEAL != selectedMealCodeDropdownValue
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "MEAL",
        ItemValue: selectedMealCodeDropdownValue,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (
      selectedListData?.BS_INTYPE != selectedInsulinTypeDropdownValue &&
      selectedInsulinTypeDropdownValue
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_INTYPE",
        ItemValue: selectedInsulinTypeDropdownValue,
        RowNum: selectedListData?.RowNum,
      });
    }
    if (
      selectedListData?.BS_ITYPE != selectedInsulinType2DropdownValue &&
      selectedInsulinType2DropdownValue
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_ITYPE",
        ItemValue: selectedInsulinType2DropdownValue,
        RowNum: selectedListData?.RowNum,
      });
    }

    if (
      selectedListData?.BS_PTYPE != selectedPumpInsulineTypeDropdownValue &&
      selectedPumpInsulineTypeDropdownValue
    ) {
      updatedData?.AdditionalBOData.ItemList.push({
        ItemId: "BS_PTYPE",
        ItemValue: selectedPumpInsulineTypeDropdownValue,
        RowNum: selectedListData?.RowNum,
      });
    }
    if (
      updatedData?.AdditionalBOData.ItemList &&
      updatedData.AdditionalBOData.ItemList.length > 0
    ) {
      return updatedData;
    } else {
      toast.success(Language.Message.noDataChanged, {
        position: "bottom-right",
        // onClose: () => navigate(URL.savedRecords),
      });
      setTimeout(() => {
        navigate(URL.savedRecords);
      }, 1000);
    }
  };

  const handleResponse = useCallback(
    (data, PageID, getListflag) => {
      if (size(data) <= 0) {
        // showToast("Data Inserted Successfully!");
      } else {
        if (data.Message !== Language.Message.unableInsert) {
          toast.success(data?.Message, {
            position: "bottom-right",
          });
        }
        setTimeout(async () => {
          handleSubmitFlagChange();
          if (
            getListflag === true ||
            data.Message === Language.Message.unableInsert
          ) {
            navigate(URL.savedRecords);
          } else {
            navigate(URL.form);
          }
        }, 1000); // Adjust the delay time as needed
        // navigate(URL.savedRecords);
      }
    },
    [getListflag]
  );

  const handleDropdownLanguageChange = (row, column, options) => {
    const itemValue = get(
      row?.ItemList.find((item) => item?.ItemId === column?.id),
      "ItemValue",
      ""
    );
    const matchedItem = options?.find((symptom) => {
      if (symptom?.english === itemValue) {
        return symptom?.english;
      }
    });
    return matchedItem?.name;
  };

  const schema = joi.object({
    Blood_sugar_value: joi.number().required().messages({
      "number.empty": Language.error.BloodSugarRecord.Blood_sugar_value.empty,
      "number.base": Language.error.BloodSugarRecord.Blood_sugar_value.base,
    }),
    Bolus_Insulin: joi.number().allow(""),
    Basal_Insulin: joi.number().allow(""),
    Pump_Insulin_Units: joi.number().allow(""),
    time_Dropdown_Value: joi.string().required().messages({
      "any.required":
        Language.error.BloodSugarRecord.time_Dropdown_Value.required,
    }),
    Meal_Code_Dropdown: joi.string().required().messages({
      "any.required":
        Language.error.BloodSugarRecord.Meal_Code_Dropdown.required,
    }),
    PumpInsulin_Type_Dropdown: joi.string().allow(""),
    Insulin_Type_Dropdown: joi.string().allow(""),
    Insulin_Type2_Dropdown: joi.string().allow(""),
  });

  return {
    submitBSData,
    updateBSData,
    selectedListData,
    loading,
    schema,
    handleResponse,
    handleDropdownLanguageChange,
  };
}
